import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Snowflake } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const location = useLocation();
  const { user, setUser } = useAuth();
  const [status, setStatus] = useState(location.state?.user || user ? "ok" : "checking");

  useEffect(() => {
    if (location.state?.user || user) {
      setStatus("ok");
      return;
    }
    let active = true;
    (async () => {
      try {
        const res = await api.me();
        if (!active) return;
        setUser(res.data);
        setStatus("ok");
      } catch {
        if (active) setStatus("no");
      }
    })();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-0">
        <Snowflake className="h-8 w-8 text-cyan-300 animate-spin" style={{ animationDuration: "2.5s" }} />
      </div>
    );
  }
  if (status === "no") return <Navigate to="/login" replace />;

  if (adminOnly && !(user?.is_admin)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
